// extracted by mini-css-extract-plugin
export default {"desktopInstructionsText":"BranchNextStepDesktop-module__desktopInstructionsText__StB6_6v"};